import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=5652f84a"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=5652f84a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5652f84a')) {
      api.createRecord('5652f84a', component.options)
    } else {
      api.reload('5652f84a', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=5652f84a", function () {
      api.rerender('5652f84a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Card.vue"
export default component.exports